import {
  DOWNLOAD_REPORT_REQUEST,
  DOWNLOADING_REPORT_SUCCEEDED,
  DOWNLOADING_REPORT_FAILED,
} from "constants/actionTypes";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;
const REPORTS_BASE_URL = `${API_URL}/api/1.0/reports`;

/** download reports */
export const downloadReport = createAction(DOWNLOAD_REPORT_REQUEST);
const downloadingReportSucceeded = createAction(DOWNLOADING_REPORT_SUCCEEDED);
const downloadingReportFailed = createAction(DOWNLOADING_REPORT_FAILED);

function* downloadReportSaga(action) {
  let { type, filterRequest } = action.payload;

  let url = buildUrl(REPORTS_BASE_URL, { path: `/download` });
  const downloadReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: {
        type,
        filterRequest,
      },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(downloadReportAPI);
    yield put(downloadingReportSucceeded(response));
  } catch (error) {
    yield put(downloadingReportFailed(error));
  }
}

export default function* reportsSaga() {
  yield takeLatest(DOWNLOAD_REPORT_REQUEST, downloadReportSaga);
}
